"use client";
import { jsx } from "react/jsx-runtime";
import { Badge as Badge$1, badgeClasses } from "@mui/base/Badge";
import { styled } from "@mui/material/styles";
import { SpaceXxs, FontLineHeightSm, FontWeightBold, SizeBorderWidthThin, ColorBlue600, ColorWhite } from "@nxt-costco-com/forge-design-tokens";
import { BADGE_HEIGHT_WIDTH } from "./constants.js";
function Badge({ children, badgeContent, max }) {
  if (!badgeContent) {
    return children;
  }
  return /* @__PURE__ */ jsx(MuiBadge, { "aria-hidden": true, badgeContent, max, children });
}
const MuiBadge = styled(Badge$1)(() => ({
  boxSizing: "border-box",
  color: ColorBlue600,
  display: "inline-block",
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  [`& .${badgeClasses.badge}`]: {
    backgroundColor: ColorWhite,
    border: `${SizeBorderWidthThin} solid ${ColorBlue600}`,
    borderRadius: "12px",
    fontSize: ".688rem",
    fontWeight: FontWeightBold,
    height: BADGE_HEIGHT_WIDTH,
    lineHeight: FontLineHeightSm,
    minWidth: BADGE_HEIGHT_WIDTH,
    padding: `0 ${SpaceXxs}`,
    position: "absolute",
    right: 7,
    textAlign: "center",
    top: 7,
    transform: `translate(50%, -50%)`,
    transformOrigin: `100% 0`,
    whiteSpace: "nowrap",
    zIndex: "auto"
  }
}));
export {
  Badge
};
